import { AxiosInstance, AxiosPromise } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';

import {
  CloneUserRoleRequest,
  CloneUserRoleResponse,
  CreateUserRoleRequest,
  CreateUserRoleResponse,
  DeleteUserRoleRequest,
  UpdateUserRoleRequest,
  UserRoleSearchRequest,
  UserRoleSearchResponse,
} from './UserRoleService.types';
import { PermissionsService } from './services';

export class UserRoleService implements BaseRequestEndpoints {
  instance: AxiosInstance;
  permissions: PermissionsService;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.permissions = new PermissionsService(this.instance);
  }

  getById(request: BaseRequest): AxiosPromise<unknown> {
    throw new Error('Method not implemented.');
  }

  create(request: CreateUserRoleRequest) {
    return this.instance.post<CreateUserRoleResponse>('/roles', request.body);
  }

  clone(request: CloneUserRoleRequest) {
    return this.instance.post<CloneUserRoleResponse>(
      `/roles/${request.routeParams.userRoleId}/clone`,
    );
  }

  search(request: UserRoleSearchRequest) {
    return this.instance.get<UserRoleSearchResponse>('/roles', { params: request.queryParams });
  }

  update(request: UpdateUserRoleRequest) {
    return this.instance.patch<void>(`/roles/${request.routeParams.userRoleId}`, request.body);
  }

  delete(request: DeleteUserRoleRequest) {
    return this.instance.delete<boolean>(`/roles/${request.routeParams.userRoleId}`);
  }
}
